import type { DocOptionRule } from "building-types/options/docOptionRule";
import { type DocOptionSet } from "building-types/options/optionSet";
import type { Table } from "common/data/table";
import type { OptionRuleReferencesByOption } from "doc/options/optionRule";
import { isBooleanOptionSet } from "doc/options/optionSetBaseUtils";
import { getReadableFormula } from "lib/house/readableFormulaUtils";

export default function getReadableOptionRules({
  optionId,
  optionSet,
  optionSets,
  optionRules,
  optionRuleReferences,
  formatForPlanLibrary,
}: {
  optionId: string | undefined;
  optionSet: DocOptionSet;
  optionSets: Table<DocOptionSet>;
  optionRules: Table<DocOptionRule>;
  optionRuleReferences: OptionRuleReferencesByOption;
  formatForPlanLibrary?: boolean;
}): string[] {
  const result: string[] = [];

  if (isBooleanOptionSet(optionSet)) {
    for (const [optId, refs] of Object.entries(optionRuleReferences)) {
      let status: string;

      if (formatForPlanLibrary) {
        status = optId === "true" ? "enabled" : "disabled";
      } else {
        status = optId === "true" ? "Enabled" : "Disabled";
      }

      for (const [ruleId, { type }] of Object.entries(refs)) {
        if (type === "EFFECT") {
          result.push(`${status} when ${getReadableFormula(optionRules[ruleId].predicate.formula, optionSets)}`);
        }
      }
    }
  } else {
    if (optionId && optionId in optionRuleReferences) {
      for (const [ruleId, { type }] of Object.entries(optionRuleReferences[optionId])) {
        if (type === "EFFECT") {
          if (formatForPlanLibrary) {
            result.push(`chosen when ${getReadableFormula(optionRules[ruleId].predicate.formula, optionSets)}`);
          } else {
            result.push(`Chosen when ${getReadableFormula(optionRules[ruleId].predicate.formula, optionSets)}`);
          }
        }
      }
    }
  }

  return result;
}
